import React from "react";

import { IconProps } from "../../types/common/icons";

const TickIcon = ({
    width = "16",
    height = "16",
    style,
    className,
    fillClassName,
    fillColor = "#63696F",
}: IconProps) => (
    <svg
        style={style}
        width={width}
        height={height}
        className={className}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M5.8667 10.6033L3.53336 8.27C3.41013 8.14524 3.24206 8.07502 3.0667 8.07502C2.89133 8.07502 2.72327 8.14524 2.60003 8.27C2.34003 8.53 2.34003 8.94334 2.60003 9.20334L5.39336 11.9967C5.65336 12.2567 6.07336 12.2567 6.33336 11.9967L13.4 4.93667C13.66 4.67667 13.66 4.26334 13.4 4.00334C13.2768 3.87857 13.1087 3.80835 12.9334 3.80835C12.758 3.80835 12.5899 3.87857 12.4667 4.00334L5.8667 10.6033Z"
            fill={fillColor!}/>
    </svg>

);

export default TickIcon;